const ACCESS_TOKEN = "accessToken";
const TOKEN_EXPIRY = "authExpiry";

const setSessionToken = (token: string) =>
  sessionStorage.setItem(ACCESS_TOKEN, token);
const setSessionExpiry = (expiryTime: string) =>
  sessionStorage.setItem(TOKEN_EXPIRY, expiryTime);

const getSessionToken = () => sessionStorage.getItem(ACCESS_TOKEN);
const getSessionExpiry = () => sessionStorage.getItem(TOKEN_EXPIRY);

export { setSessionToken, setSessionExpiry, getSessionToken, getSessionExpiry };
// Info: The above code snippet is used to manage the session storage of the access token and its expiry time. The setAuthToken function is used to set the access token in the session storage, the setAuthExpiry function is used to set the expiry time of the token in the session storage, the getAuthToken function is used to get the access token from the session storage, and the getAuthExpiry function is used to get the expiry time of the token from the session storage.
